<template>
  <div class="news-component-bg" v-if="newsList && newsList[newsListIndex]">
    <!-- PICTURE OUTSIDE CONTAINER FOR SMALL BREAKPOINT AND SMALLER -->
    <v-img
      v-if="!lgAndUp"
      @load="reactOnImageLoad()"
      :class="getImageClass"
      :src="newsList[newsListIndex].image.url"
      :height="
        $vuetify.breakpoint.xs
          ? $vuetify.breakpoint.width
          : $vuetify.breakpoint.height * (2 / 3)
      "
      width="100%"
      eager
      dark
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-container class="v-container--no-vertical-paddings">
      <v-row>
        <v-col
          sm="12"
          :lg="$vuetify.breakpoint.xl ? 3 : 4"
          align-self="center"
          :class="`v-col--extra-vertical-paddings ${componentStyle}`"
        >
          <div class="news">
            <div
              class="tx-1 tx-b-700 tx-dark-gray"
              :style="loggedIn ? 'display: flex; align-items: center;' : ''"
            >
              Bądź na bieżąco!
            </div>
            <div class="tx-3 tx-b-500">
              <!--              ({{ newsListIndex + 1 }}/{{ newsList.length }})-->
              {{ newsList[newsListIndex].title }}
            </div>
            <div class="tx-4">
              {{ newsList[newsListIndex].briefly }}
              <div v-html="newsList[newsListIndex].link"></div>
              <a
                v-if="newsList[newsListIndex].content !== null"
                @click="navigateToNewsPage(newsList[newsListIndex])"
                class="link"
              >
                Dowiedz się więcej...</a
              >
            </div>
          </div>

          <!-- NEWS NAVIGATION BUTTONS -->
          <div class="news-navigation">
            <v-btn @click="changeNews('previous')" class="v-btn-news-navigator">
              <div class="v-btn-news-navigator__text">Poprzedni wpis</div>
            </v-btn>
            <v-btn @click="changeNews('next')" class="v-btn-news-navigator">
              <div class="v-btn-news-navigator__text">Następny wpis</div>
            </v-btn>
          </div>
        </v-col>
        <v-col class="d-none d-xl-flex" :cols="1"></v-col>

        <!-- PICTURE INSIDE CONTAINER FOR LARGE BREAKPOINT AND BIGGER-->
        <v-col v-if="lgAndUp" class="v-col--no-vertical-paddings" lg="8">
          <div class="w-100">
            <v-img
              :src="newsList[newsListIndex].image.url"
              :height="$vuetify.breakpoint.height * (2 / 3)"
              :class="getImageClass"
              @load="reactOnImageLoad()"
              width="100%"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { News } from "@/models/news.model";
import { backendUrl } from "@/backend";
import websiteContents from "@/website-contents";

export default {
  name: "news-component",
  data: function() {
    return {
      imageLoaded: false,
      newsList: null,
      newsListIndex: 0,
      showNewsManagerModal: false,
      availableDefaultImageIds: [],
      defaultImagesCount: 5,
      componentStyle: "",
      newsAutoChangerSet: false,
      backendUrl: backendUrl
    };
  },
  mounted: function() {
    this.getNewsList();
  },
  computed: {
    loggedIn: function() {
      return this.$store.state.authentication.loggedIn;
    },

    lgAndUp: function() {
      return this.$vuetify.breakpoint.lgAndUp;
    },

    getImageClass: function() {
      return (
        "news-image" +
        (this.imageLoaded === true
          ? " news-image--opacity-1"
          : " news-image--opacity-0")
      );
    }
  },
  methods: {
    reactOnImageLoad() {
      if (this.newsList && !this.imageLoaded) {
        this.$emit("loading-finished");
      }
      this.imageLoaded = true;
    },
    getNewsList() {
      this.newsList = new Array(new News());
      this.newsList = websiteContents.news;
      this.handleNewsChange(0);
      this.setNewsAutoChanger();
    },

    setNewsAutoChanger() {
      if (!this.newsAutoChangerSet) {
        setInterval(() => {
          setTimeout(() => {
            this.changeNews("next");
          }, 500);
        }, 10000);
      }
    },

    changeNews: function(to) {
      this.componentStyle = "transition transition--start";
      this.imageLoaded = false;
      let newsListIndex = this.newsListIndex;
      switch (to) {
        case "next":
          if (newsListIndex < this.newsList.length - 1) {
            newsListIndex = newsListIndex + 1;
          } else {
            newsListIndex = 0;
          }
          break;
        case "previous":
          if (newsListIndex > 0) {
            newsListIndex = newsListIndex - 1;
          } else {
            newsListIndex = this.newsList.length - 1;
          }
          break;
      }

      setTimeout(() => this.handleNewsChange(newsListIndex), 200);
    },

    handleNewsChange: function(newsListIndex) {
      this.newsListIndex = newsListIndex;
      if (!this.newsList[newsListIndex].image) {
        this.newsList[newsListIndex].image = {
          url: this.getPlaceholderImageUrl()
        };
      }
      this.componentStyle = "transition transition--end";
    },

    getPlaceholderImageUrl: function() {
      if (this.availableDefaultImageIds.length < 1) {
        for (let i = 0; i < this.defaultImagesCount; i++) {
          this.availableDefaultImageIds.push(i);
        }
      }

      return require(`@/assets/images/default_${this.availableDefaultImageIds.pop()}.webp`);
    },

    navigateToNewsPage: function(news) {
      this.$router.push(`/nowosci/${news.id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.transition {
  transition: opacity 250ms;
}

.transition--start {
  opacity: 0;
}

.transition--end {
  opacity: 1;
}

.news-image--opacity-1 {
  opacity: 1 !important;
}

.news-image {
  opacity: 0;
  transition: opacity 0.2s linear;
}

.v-col--extra-vertical-paddings {
  padding-top: 24px;
  padding-bottom: 24px;
}

.v-col--no-vertical-paddings {
  padding-top: 0;
  padding-bottom: 0;
}

.v-container--no-vertical-paddings {
  padding-top: 0;
  padding-bottom: 0;
}

.news {
  color: #707070;
}

.news-navigation {
  margin-top: 19px;
}

.v-btn-news-navigator {
  margin-right: 12px;
}

.v-btn-news-navigator__text {
  font-size: 16px;
  font-weight: bolder;
  color: #707070;
  text-transform: none;
  letter-spacing: 0;
}

.news-component-bg {
  width: 100%;
  background-color: #e9e9e9;
}

.link {
  text-decoration: none;
  color: #0c9a9a;
}
</style>
